<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="platform in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-3
        p.mb-0 Mostrar productos
        p.text-secondary.text-sm Muestra una lista de productos en una galería dentro de la conversación.
        result-description.mb-3(variable-name="product", variable-type="object")
        fieldset.mb-3(:disabled="disabled")
          b-form-group(label="Límite productos mostradas:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'limit'")
            k-select.disabled-white(placeholder="- Seleccionar límite -", :options="generateNumberOptions(10, 0)", :disabled="disabled", :value="template_attribute.value || null", @input="updateTemplateAttribute(template_attribute, $event)", :searchable="false")
          b-form-group(label="Categoría del producto:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'category_id'")
            b-form-radio-group.mb-2(v-model="category_select", :options="category_options", @change="clearSelectedValue")
            k-select.disabled-white(v-if="category_select==='predefined'", placeholder="- Seleccionar categoría -", :options="categories", :disabled="disabled", :value="template_attribute.value || null", @input="updateTemplateAttribute(template_attribute, $event)")
            b-form-group(v-else-if="category_select==='custom'")
              vue-tribute(:options="tributeOpts")
                b-form-input.disabled-white(placeholder="Nombre de categoría", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group(label="Filtrar productos:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name == 'sort_by'")
            b-form-select(:value="template_attribute.value || null", @change="updateTemplateAttribute(template_attribute, $event)")
              option(:value="null", disabled) --Selecciona filtro--
              option(v-for="filter in product_filters", :key="filter.value", :value="filter.value") {{filter.name}}
          b-form-checkbox.mb-3(switch, v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'advance_search'", :checked="parseBoolean(template_attribute.value)", @change="update(template_attribute, $event)") Búsqueda avanzada de categorías
          b-collapse.mb-3(:visible="advance_search", :id="`advance_search_collapse_${template_id}`")
            b-form-group(label="Tipo de busqueda:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name == 'category_operator'")
              b-form-select(:value="template_attribute.value || null", @change="updateTemplateAttribute(template_attribute, $event)")
                option(:value="null", disabled) --Selecciona tipo--
                option(v-for="operator in operator_options", :key="operator.value", :value="operator.value") {{operator.name}}
            action-show-products-element(v-for="element in Elements", :key="element.element_id", v-if="element.type === 'category_element'", :id="`element_${element.element_id}`", :disabled="disabled", :block_id="block_id", v-bind="element", @destroy="destroyTemplateElement(element)")
            add-element-button(v-if="!disabled", @click="createTemplateElement", title="Agregar categoria")
      gallery-element.mb-3(v-for="element in Elements", :key="element.element_id", v-if="element.type === 'gallery_element'", :id="`element_${element.element_id}`", :disabled="disabled", :block_id="block_id", v-bind="element", single)
      template-connector(v-for="connector in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import templateCommon from '@/helpers/template-common'
import Connector from '@/components/templates/connectors/Connector.vue'
import GalleryElement from '@/components/templates/GalleryElement.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import ResultDescription from '@/components/templates/helpers/ResultDescription'
import AddElementButton from '@/components/AddElementButton.vue'
import ActionShowProductsElement from '@/components/templates/ActionShowProductsElement.vue'
import _debounce from 'lodash.debounce'
import { createNamespacedHelpers, mapActions } from 'vuex'

const categoryController = createNamespacedHelpers('category')

export default {
  mixins: [templateCommon],
  data () {
    return {
      category_select: 'custom',
      category_options: [
        {text: 'Predefinida', value: 'predefined'},
        {text: 'Personalizada', value: 'custom'}
      ],
      product_filters: [
        {name: 'Más vendido', value: 'sold'},
        {name: 'Prioridad', value: 'priority'},
        {name: 'Precio', value: 'price'},
        {name: 'Fecha de creación', value: 'createdAt'}
      ],
      order_options: [
        {name: 'Ascendente', value: 'ASC'},
        {name: 'Descendente', value: 'DESC'}
      ],
      operator_options: [
        {value: 'AND', name: 'Todos'},
        {value: 'OR', name: 'Al menos uno'}
      ],
    }
  },
  computed: {
    ...categoryController.mapState({
      categories: state => state.categories.map(c => {
        return {
          label: c.name,
          id: c.category_id
        }
      })
    }),
    advance_search () {
      let advance_search_attribute = this.getAttribute('advance_search')
      if (advance_search_attribute) {
        return this.parseBoolean(advance_search_attribute.value)
      }

      return false
    }
  },
  methods: {
    ...mapActions(['category/all']),
    update (template_attribute, value) {
      template_attribute.value = value
      let attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, attribute)
    },
    getCategories () {
      let self = this

      this['category/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let category_id = self.getAttribute('category_id')
            if(category_id){
              let categ = self.categories.find(c => c.id == category_id.value)
              self.category_select = categ ? 'predefined' : 'custom'
            }
          }
        }
      })
    },
    createTemplateElement () {
      let element = {
        type: 'category_element',
        number: this.Elements.length + 1,
        attributes: [
          {
            name: 'category_id',
            value: null
          },
          {
            name: 'category_input',
            value: 'text'
          }
        ]
      }
      this.createElement(this.block_id, this.template_id, element)
    },
    destroyTemplateElement (element) {
      this.destroyElement(this.block_id, this.template_id, element)
    },
    clearSelectedValue () {
      let category_id = this.getAttribute('category_id')
      if(category_id) category_id.value = ''
    }
  },
  components: {
    'template-connector': Connector,
    GalleryElement,
    TemplateTools,
    ResultDescription,
    AddElementButton,
    ActionShowProductsElement
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId == `advance_search_collapse_${this.template_id}`) {
        setTimeout(() => {
          this.repaintBlock()
        }, 500)
      }
    })
    this.getCategories()
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      let newValue

      if (value && value.target) {
        newValue = value.target._value
      } else {
        newValue = value
      }

      this.update(template_attribute, newValue)

      this.$message.success('Actualizado')
    }, 100, { leading: false, trailing: true })
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-action-show-products-template {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
